import { render } from "./LeaveBalance.vue?vue&type=template&id=642bc4ee&scoped=true"
import script from "./LeaveBalance.vue?vue&type=script&lang=js"
export * from "./LeaveBalance.vue?vue&type=script&lang=js"

import "./LeaveBalance.vue?vue&type=style&index=0&id=642bc4ee&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642bc4ee"]])

export default __exports__